module.exports = __webpack_public_path__ + "static/media/document-attach.5bd5b610.svg";